import rawRegistry from './fundraising-platform-pricing.json';
import { FUNDRAISER_PROFILE_REGISTRY } from './fundraiser-profile.config';
import type {
  ComparisonOptionSelections,
  FundraisingComparisonState,
  FundraisingPricingRegistry,
  PlatformId,
  PlatformCategoryDefinition,
  PlatformOptionSelections,
  PlatformPricingConfiguration,
} from '../models/fundraising-comparison.models';
import { validateFundraisingPricingRegistry } from './pricing-registry.validator.mjs';

export const FUNDRAISING_PRICING_REGISTRY: FundraisingPricingRegistry =
  validateFundraisingPricingRegistry(rawRegistry);

export const FUNDRAISING_COMPARISON_DEVELOPMENT_MODE =
  FUNDRAISING_PRICING_REGISTRY.developmentMode;

export function getPlatformCategories(): PlatformCategoryDefinition[] {
  return FUNDRAISING_PRICING_REGISTRY.platformCategories;
}

export function getAvailablePricingConfigurations(): PlatformPricingConfiguration[] {
  const platformsById = new Map(
    FUNDRAISING_PRICING_REGISTRY.platforms.map((platform) => [
      platform.id,
      platform,
    ]),
  );
  return FUNDRAISING_PRICING_REGISTRY.canonicalPlatformOrder
    .map((platformId) => platformsById.get(platformId)!)
    .filter((platform) => platform.comparisonEnabled);
}

export function getPricingConfiguration(
  platformId: PlatformId,
): PlatformPricingConfiguration | undefined {
  return FUNDRAISING_PRICING_REGISTRY.platforms.find(
    (platform) => platform.id === platformId,
  );
}

export function getDefaultOptionSelections(): ComparisonOptionSelections {
  return Object.fromEntries(
    getAvailablePricingConfigurations().map((platform) => [
      platform.id,
      Object.fromEntries(
        platform.optionGroups.map((group) => [group.id, group.defaultChoiceId]),
      ) satisfies PlatformOptionSelections,
    ]),
  ) as ComparisonOptionSelections;
}

export function createDefaultComparisonState(): FundraisingComparisonState {
  return {
    version: 3,
    intendedGiftTotalCents: 2_000_000,
    profileId: FUNDRAISER_PROFILE_REGISTRY.defaultProfileId,
    donationCountOverride: null,
    platformIds: [...FUNDRAISING_PRICING_REGISTRY.defaultComparisonPlatformIds],
    optionSelections: getDefaultOptionSelections(),
  };
}
